<app-modal-title i18n>Duplicate plan</app-modal-title>
<app-modal-body>
    <div class="ot-m-1">
        <app-plans-form [mode]="mode" [plan]="plan" (formEvent)="updateForm($event)"></app-plans-form>
    </div>
</app-modal-body>
<app-modal-footer>
    <button id="plan-duplicate-btn" otsc-button color="primary" i18n-title title="Duplicate" (click)="duplicatePlan()" [disabled]="!this.formGroup.valid" i18n> 
        Duplicate
    </button>
    <button id="plan-cancel-btn" otsc-button color="secondary" i18n-title title="Cancel" (click)="cancel()" [disabled]="isSaving" i18n>
        Cancel
    </button>
</app-modal-footer>